// src/components/platform/EcosystemFeature.tsx

import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

interface EcosystemFeatureProps {
  text: string;
  index: number;
}

export const EcosystemFeature1: React.FC<EcosystemFeatureProps> = ({ text, index }) => {
  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5, delay: index * 0.1, ease: 'easeOut' } },
  };

  return (
    <motion.li variants={itemVariants} className="flex items-start gap-4">
      <Star size={22} className="text-amber-400 fill-current mt-1 flex-shrink-0" />
      <p className="text-lg text-slate-700">{text}</p>
    </motion.li>
  );
};